<template>
  <a-box>
    <o-form
      async
      :title="$t('reporting.checkComponents')"
      :subtitle="$t('reporting.checkComponentsDescription')"
      :submit-text="$t('reporting.checkComponents')"
      submit-disabled-reason=""
      @submit="triggerCPVCheck"
    />
  </a-box>
</template>

<script>
  import { useTriggerCPVCheck } from '@/views/reporting/reportingHooks'
  import { ABox, OForm } from 'codefabrik-gui-vue'

  export default {
    name: 'CPVCheckTrigger',
    components:{ OForm, ABox },
    mixins: [useTriggerCPVCheck()]
  }
</script>

<style scoped>

</style>
